import React from 'react';
import { logger } from '../lib/logger';

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type State = { hasError: boolean };

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: any, info: any) {
    logger.error(
      {
        error: typeof error?.message === 'string' && error.message ? error.message : String(error),
        stack: typeof error?.stack === 'string' ? error.stack : undefined,
        componentStack: typeof info?.componentStack === 'string' ? info.componentStack : undefined,
        pathname: window.location.pathname,
      },
      'ErrorBoundary caught error',
    );
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <div className="p-4 text-sm text-rose-700">Something went wrong.</div>;
    }
    return this.props.children;
  }
}
